import { withErrorBoundary } from '@edreamsodigeo/frontend-core';

import { withModuleContext } from '~hocs';
import HotelDealsMobileCardContainer from './HotelDealsMobileCardContainer';
import HotelDealsMobileCardContainerMeta from './HotelDealsMobileCardContainerMeta';

export default withModuleContext(
  withErrorBoundary(HotelDealsMobileCardContainer, {
    name: 'HotelDealsMobileCardContainer',
  })
);

const HotelDealsMobileCardContainerMetaWithModuleContext = withModuleContext(
  withErrorBoundary(HotelDealsMobileCardContainerMeta, {
    name: 'HotelDealsMobileCardContainerMeta',
  })
);

export { HotelDealsMobileCardContainerMetaWithModuleContext as HotelDealsMobileCardContainerMeta };
